export const REDIS_TTL_SECONDS = 60 * 10; // 10 minutes

export const RedisKey = {
  Page: 'page',
  PageNinetailedData: 'page_nt_data',
  SiteSettings: 'site_settings',
  ItgConcepts: 'itg_concepts',
} as const;

export type RedisKeyType = (typeof RedisKey)[keyof typeof RedisKey];
